//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"SelectPoint",1,"Point",0],[0,"VectorDefineDirection",1,"Direction",0]],[[[],"ReverseVector",{},0,0],[[],"PointSubFunction",{},0,0],[["curveTag"],"RemoveLast",{},1,0],[["curveList"],"RemoveAll",{},1,0],[["pointData","direction"],"CreateTemporaryLine",{R_:{curveTag:"Line"}},2,0]],[]];
SPLM.Tooling.SectionLineCreationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.SectionLineCreationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;